import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

type StepSelectorGroupProps = {
    width?: number;
};

const useStyles = makeStyles({
    container: (props: StepSelectorGroupProps) => ({
        width: props.width,
        marginBottom: 32
    })
});

export const StepSelectorGroup: React.FC<StepSelectorGroupProps> = props => {
    const styles = useStyles(props);
    return <div className={styles.container}>{props.children}</div>;
};
